import { Panel } from "../../../../components/panels/Panel";


export const DiorDataDashboardPreciousDataBlock = ({ dataName, values, unitTexts }) => {
  return (
    <Panel noHeader rounded category="secondary">
      <div className="flex flex-col gap-4">
        <div className="text-perception-gray-600">
          {dataName}
        </div>

        <div className="flex gap-4">
          <div className="flex flex-col gap-2 w-full">
            <div className="text-sm">
              {unitTexts[0]}
            </div>
            <div className="text-3xl">
              {values[0]}
            </div>
          </div>

          <div className="flex flex-col gap-2 w-full">
            <div className="text-sm">
              {unitTexts[1]}
            </div>
            <div className="text-3xl">
              {values[1]}
            </div>
          </div>
        </div>
      </div>
    </Panel>
  );
};